/**
 * Debug Controls for Performance Optimization
 * 
 * This utility provides easy control over debug logging to improve performance.
 * In production, all debug logging is automatically disabled.
 * In development, users can control logging granularly.
 * 
 * Usage in browser console:
 * 
 * // Enable all debug logging
 * window.enableAllDebug();
 * 
 * // Disable all debug logging  
 * window.disableAllDebug();
 * 
 * // Enable specific component logging
 * window.DEBUG_CHARACTER_MANAGEMENT = true;
 * window.DEBUG_VARIATION_LIST = true;
 * window.DEBUG_VARIATION_VERSIONS = true;
 * 
 * // Check current debug status
 * window.getDebugStatus();
 */

// Initialize debug controls only in development
if (process.env.NODE_ENV === 'development') {

  // Enable all debug logging
  window.enableAllDebug = () => {
    window.DEBUG_CHARACTER_MANAGEMENT = true;
    window.DEBUG_VARIATION_LIST = true;
    window.DEBUG_VARIATION_VERSIONS = true;
    window.DEBUG_PERFORMANCE = true;
    window.DEBUG_RENDERS = true;
    window.DEBUG_SELECTORS = true;
    window.DEBUG_MEMOIZATION = true;
    window.DEBUG_VARIATION_FORM = true;
    console.log('✅ All debug logging enabled');
    console.log('Current debug status:', window.getDebugStatus());
  };

  // Disable all debug logging
  window.disableAllDebug = () => {
    window.DEBUG_CHARACTER_MANAGEMENT = false;
    window.DEBUG_VARIATION_LIST = false;
    window.DEBUG_VARIATION_VERSIONS = false;
    window.DEBUG_PERFORMANCE = false;
    window.DEBUG_RENDERS = false;
    window.DEBUG_SELECTORS = false;
    window.DEBUG_MEMOIZATION = false;
    window.DEBUG_VARIATION_FORM = false;
    console.log('❌ All debug logging disabled');
    console.log('Current debug status:', window.getDebugStatus());
  };

  // Get current debug status
  window.getDebugStatus = () => {
    return {
      CHARACTER_MANAGEMENT: !!window.DEBUG_CHARACTER_MANAGEMENT,
      VARIATION_LIST: !!window.DEBUG_VARIATION_LIST,
      VARIATION_VERSIONS: !!window.DEBUG_VARIATION_VERSIONS,
      PERFORMANCE: !!window.DEBUG_PERFORMANCE,
      RENDERS: !!window.DEBUG_RENDERS,
      SELECTORS: !!window.DEBUG_SELECTORS,
      MEMOIZATION: !!window.DEBUG_MEMOIZATION,
      VARIATION_FORM: !!window.DEBUG_VARIATION_FORM
    };
  };

  // Initialize with all debug logging disabled for better performance
  window.disableAllDebug();

  console.log('🔧 Debug controls initialized. Use window.enableAllDebug() or window.disableAllDebug() to control logging.');

} else {
  // In production, ensure all debug flags are false
  window.DEBUG_CHARACTER_MANAGEMENT = false;
  window.DEBUG_VARIATION_LIST = false;
  window.DEBUG_VARIATION_VERSIONS = false;
  window.DEBUG_PERFORMANCE = false;
  window.DEBUG_RENDERS = false;
  window.DEBUG_SELECTORS = false;
  window.DEBUG_MEMOIZATION = false;
  window.DEBUG_VARIATION_FORM = false;
}

export default {
  enableAllDebug: window.enableAllDebug,
  disableAllDebug: window.disableAllDebug,
  getDebugStatus: window.getDebugStatus
};
